import { c as _c } from "react/compiler-runtime";
import { useMembersMenuOptions } from "@pages/members/use-members-menu-options";
import { MemberMobileList } from "@components/common/mobile/member-mobile-list";
/**
 * Mobile-specific view for team members list.
 * Renders a virtualized list of team members with selection, menu options, and bulk actions.
 */
export function TeamMembersMobileView(t0) {
  const $ = _c(9);
  const {
    members,
    bulkActionButtons,
    isLoading,
    sortBy,
    team,
    loadMoreItems
  } = t0;
  let t1;
  if ($[0] !== team) {
    t1 = {
      subjectType: "team",
      team
    };
    $[0] = team;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const menuItems = useMembersMenuOptions(t1);
  let t2;
  if ($[2] !== bulkActionButtons || $[3] !== isLoading || $[4] !== loadMoreItems || $[5] !== members || $[6] !== menuItems || $[7] !== sortBy) {
    t2 = <MemberMobileList members={members} isLoading={isLoading} bulkActionButtons={bulkActionButtons} tableSubject="team" menuItems={menuItems} loadMoreItems={loadMoreItems} sortBy={sortBy} />;
    $[2] = bulkActionButtons;
    $[3] = isLoading;
    $[4] = loadMoreItems;
    $[5] = members;
    $[6] = menuItems;
    $[7] = sortBy;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}